import './registerHooks.js'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "amfe-flexible"
import jsCookie from 'js-cookie'
Vue.prototype.$cookie = jsCookie
Vue.config.productionTip = false
import NutUI from '@nutui/nutui'
import '@nutui/nutui/dist/nutui.css'
NutUI.install(Vue, NutUI)
// import wx from "weixin-js-sdk";
// Vue.prototype.$wx = wx
import Videojs from 'video.js'
import 'video.js/dist/video-js.css'
Vue.prototype.$video = Videojs
import waterfall from 'vue-waterfall2'
import Vant from 'vant'
import 'vant/lib/index.css'
Vue.use(Vant)
Vue.use(waterfall)

router.beforeEach((to: any, from, next) => {
  if (to.meta.title !== undefined) {
    window.document.title = to.meta.title;
  }
  next();
})
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
